import { trans } from '@lingoda/i18n';
import { Button, type ButtonProps } from '@lingoda/ui';

type CheckoutButtonProps = Omit<ButtonProps, 'children' | 'color' | 'variant'>;

export const CheckoutButton = (props: CheckoutButtonProps) => (
    <Button {...props} variant="contained" color="primary" data-cy="proceed-to-checkout-btn">
        {trans('proceed-to-checkout', {}, 'student-store')}
    </Button>
);

export const CheckoutTrialButton = (props: CheckoutButtonProps) => (
    <Button {...props} variant="contained" color="primary">
        {trans('proceed-to-checkout-with-trial', {}, 'student-store')}
    </Button>
);

export const CheckoutSkipTrialButton = (props: CheckoutButtonProps) => (
    <Button {...props} variant="outlined" color="primary">
        {trans('proceed-to-checkout-skipping-trial', {}, 'student-store')}
    </Button>
);
